export const ANNOUNCEMENTS_TYPES = {
  ANNOUNCEMENT: 'announcement',
  PROGRESS: 'progress',
} as const;
